import { Card, Col, Row, Skeleton, Typography } from "antd";
import axios from "axios";
import AboutCompany from "components/AboutCompany/AboutCompany";
import SanitizeHTML from "components/SanitizeHTML/SanitizeHTML";
import JobDescription from "containers/SingleJobPosting/JobDescription/JobDescription";
import dayjs from "dayjs";
import { Company } from "interfaces/companies";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ContactPerson, JobPosting } from "./interfaces";

const { Title, Text } = Typography;

const SingleJobPosting = () => {
  const { id } = useParams<{ id: string }>();

  const [jobPosting, setJobPosting] = useState<JobPosting>();
  const [company, setCompany] = useState<Company>();
  const [contactPerson, setContactPerson] = useState<ContactPerson>();

  useEffect(() => {
    axios.get<JobPosting>(`/jobs/${id}/`).then(response => {
      setJobPosting(response.data);
    });
  }, [id]);

  useEffect(() => {
    if (!jobPosting) return;
    axios.post(`/jobs/${jobPosting.id}/view/`);
  }, [jobPosting]);

  useEffect(() => {
    if (jobPosting?.company)
      axios.get<Company>(`/companies/${jobPosting.company}/`).then(response => {
        setCompany(response.data);
      });
  }, [jobPosting?.company]);

  useEffect(() => {
    if (jobPosting?.company_contact)
      axios
        .get<ContactPerson>(`/companies/${jobPosting.company}/contact-persons/${jobPosting.company_contact}/`)
        .then(response => {
          setContactPerson(response.data);
        });
  }, [jobPosting?.company_contact, jobPosting?.company]);

  return (
    <Row justify="center" style={{ width: "100%", paddingLeft: "5%", paddingRight: "5%", paddingTop: "3%" }}>
      <Row justify="center" style={{ width: "100%" }} gutter={[40, 32]}>
        <Col
          xs={{ span: 24, order: 2 }}
          sm={{ span: 24, order: 2 }}
          md={{ span: 8, order: 1 }}
          lg={{ span: 6, order: 1 }}
        >
          <JobDescription
            companyId={company?.id}
            imageLink={company?.logo}
            job={jobPosting}
            contactPerson={contactPerson}
          />
        </Col>

        <Col
          xs={{ span: 24, order: 1 }}
          sm={{ span: 24, order: 1 }}
          md={{ span: 16, order: 2 }}
          lg={{ span: 18, order: 2 }}
        >
          <Card style={{ height: "100%" }}>
            {jobPosting ? (
              <>
                <Text type="secondary" style={{ fontSize: "0.8em" }}>
                  Publisert {dayjs(jobPosting?.created_at).format("DD.MM.YYYY")}
                </Text>
                <Title style={{ marginTop: 0 }}>{jobPosting?.title}</Title>
                <SanitizeHTML html={jobPosting?.description ?? ""} />
              </>
            ) : (
              <Skeleton active />
            )}
          </Card>
        </Col>

        <Col span={24} order={3}>
          {jobPosting && company && <AboutCompany company={company} />}
        </Col>
      </Row>
    </Row>
  );
};

export default SingleJobPosting;
